module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"actionLogEntryType":{"0":"Update Requested","1":"Record Update Successful","2":"Record Update Failed"},"Latest record updates":"Latest record updates","Refresh":"Refresh","Remote Address":"Remote Address","Time":"Time","Action":"Action","Details":"Details","No record updates found.":"No record updates found."}}')
  delete Component.options._Ctor
}
